import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoGarantia } from '../_models/producto-garantia';

@Injectable({
  providedIn: 'root'
})
export class ProductoGarantiaService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosGarantias';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoGarantia[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoGarantia[] ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as ProductoGarantia[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoGarantia ) );
  }

  crear( regCrear: ProductoGarantia ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoGarantia ) );
  }

  actualizar( regActualizar: ProductoGarantia ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

}
